<template>
	<div class="tables-section-container">
		<div class="rooms-container" :class="{reservations: roomsOrdersStore.reservationsTablesActive}">
			<div class="date-picker-container" v-if="roomsOrdersStore.reservationsTablesActive">

				<div class="date-picker-button date-picker-left" :class="{disabled: roomsOrdersStore.reservationsSelectedDate === null}" @click="reservationsLeftClick"><AppChevronIcon direction="left" /></div>
				<DatePicker ref="date-picker" mode="date" color="teal" v-model="roomsOrdersStore.reservationsSelectedDate" :is-dark="userStore.darkMode">
					<template #default="{ togglePopover }">
						<p class="reservation-date" :class="{today: isReservationsDateToday}" @click="togglePopover">{{ formattedReservationsDate }}</p>
					</template>
				</DatePicker>
				<div class="date-picker-button date-picker-right" :class="{disabled: roomsOrdersStore.reservationsSelectedDate === null}" @click="reservationsRightClick"><AppChevronIcon direction="right" /></div>

			</div>
			<div class="rooms-scroll-container" v-else>
				<div class="rooms-filter-container">
					<div class="room" :class="{active: roomsStore.activeRoomId && roomsStore.activeRoomId === room.room_id}" v-for="room in roomsStore.roomsTables" :key="room.room_id" @click="changeSelectedRoom(room)">
						<div class="cover-container" v-show="!!roomCallsQuantity(room.room_id)">
							<div class="cover-icon" v-html="svgStore.get('iconBell')"></div>
							<div class="cover-value">{{ roomCallsQuantity(room.room_id) }}</div>
						</div>
						<div class="room-name">{{ room.name ? room.name : getString('no_name') }}</div>
					</div>
				</div>
			</div>
			<div class="switchs">
				<div class="order-switch primary" v-if="roomsOrdersStore.reservationsTablesActive" v-html="svgStore.get('iconPlus')" @click="roomsOrdersStore.newReservationTableId = true"></div>
				<div class="order-switch" v-if="roomsOrdersStore.reservationsTablesActive" :class="{active: reservationsFiltersHighlighted}" v-html="svgStore.get('iconFilter')" @click="reservationsFiltersActive = true"></div>
				<div class="order-switch" v-if="!roomsOrdersStore.reservationsTablesActive" :class="{active: roomsOrdersStore.askedAssistanceFilter || roomsStore.reverseOrder || roomsStore.showFreeTables !== roomsStore.showOccupiedTables}" v-html="svgStore.get('iconFilter')" @click="filtersActive = true"></div>
				<div class="order-switch" v-if="userStore.hasReservations && experiencesStore.hasExperiences" :class="{active: roomsOrdersStore.reservationsTablesActive}" v-html="svgStore.get('iconReservations')" @click="toggleReservations"></div>
			</div>
		</div>
		<router-view 
			:opening-table="openingTable"
			:covers-num="coversNum"
			:pay-bill-table="payBillTable"
			@table-clicked="clickTable"
			@add-order-table="addOrderTable"
		/>
		<AppPopup
			:title="getString('how_many_people')"
			:bodyText="getString('how_many_people_explain')"
			ref="confirm-cover"
			:buttons="popupButtons" >
			<div class="container-input mb-15">
				<TouchNumberInput :min="0" :value="openingTable && openingTable.seat_number ? openingTable.seat_number : 1" @changed-value="v => coversNum = v" />
			</div>
		</AppPopup>
		<AppBottomSheet :active="filtersActive" :force-width="bottomSheetWidth" @toggling-popup="togglingFilters">
			<div class="filters-active" v-if="filtersActive">
				<ModalHeader :title="getString('room_filters')" />
				<RoomFilters @close="filtersActive = false" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :active="reservationsFiltersActive" :force-width="bottomSheetWidth" @toggling-popup="togglingReservationsFilters">
			<div class="filters-active" v-if="reservationsFiltersActive">
				<ModalHeader :title="getString('reservations_filters')" :button-text="getString('confirm')" @click-button="refreshReservations" />
				<ReservationsFilters @close="reservationsFiltersActive = false" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :active="payBillTable" :force-width="bottomSheetWidth" @toggling-popup="togglingPayBillTable">
			<div class="pay-bill-numpad" v-if="payBillTable">
				<ModalHeader :title="getString('send_bill_table', [payBillTableName])" />
				<PayBillNumpad :table="payBillTable" @order-created="payBillOrderCreated" />
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import {useCounterStore, useExperiencesStore, useOrdersStore, useRoomsOrdersStore, useRoomsStore, useUserStore} from "@/console-new/stores";
import {useCurrencyStore, useNotificationStore, useLanguageStore, useSvgStore} from "@/shared/stores";
import AppPopup from "@/shared/components/AppPopup.vue";
import TouchNumberInput from "@/console-new/components/shared/TouchNumberInput.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import RoomFilters from "@/console-new/components/ops/tables/RoomFilters.vue";
import PayBillNumpad from "@/console-new/components/ops/counter/PayBillNumpad.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import ReservationsFilters from "@/console-new/components/ops/tables/ReservationsFilters.vue";
import {formatDateOnly} from "@/shared/helpers/dates";

export default {
	components: {AppChevronIcon, AppTextInput, PayBillNumpad, RoomFilters, ModalHeader, AppBottomSheet, AppPopup, TouchNumberInput, ReservationsFilters},
	setup() {
		const roomsStore = useRoomsStore();
		const roomsOrdersStore = useRoomsOrdersStore();
		const languageStore = useLanguageStore();
		const svgStore = useSvgStore();
		const counterStore = useCounterStore();
		const userStore = useUserStore();
		const ordersStore = useOrdersStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		const experiencesStore = useExperiencesStore();
		return {roomsStore, languageStore, getString: languageStore.getString, roomsOrdersStore, notificationStore, currencyStore, svgStore, counterStore, userStore, ordersStore, experiencesStore};
	},
	name: "TablesContainer",
	data() {
		return {
			openingTable: null,
			coversNum: 1,
			dateInterval: null,
			reservationInterval: null,
			reservationTimeCheck: null,
			filtersActive: false,
			reservationsFiltersActive: false,
			payBillTable: null,
			answeringAssistance: false,
		}
	},
	mixins: [WindowWidth],
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		activeRoomTables() {
			if(this.roomsStore.activeRoom) {
				let returningActiveTables = this.roomsStore.activeRoom.tables
					.filter(table => {
						if(table.openDate) {
							return this.roomsStore.showOccupiedTables;
						} else {
							return this.roomsStore.showFreeTables;
						}
					})
					.sort((a, b) => {
						if(this.roomsStore.reverseOrder) {
							return b.order_number - a.order_number;
						} else {
							return a.order_number - b.order_number;
						}
					});
				if(this.roomsOrdersStore.askedAssistanceFilter) {
					returningActiveTables = returningActiveTables.filter(table => !!this.roomsOrdersStore.rtcTablesIds[table.room_table_id]);
				}
				return returningActiveTables;
			} else {
				return [];
			}
		},
		payBillTableName() {
			if(this.payBillTable) {
				return this.payBillTable.table_name;
			} else {
				return "";
			}
		},
		popupButtons() {
			let buttons = [
				{text: this.getString('cancel'), callback: this.cancelOpenTable, negative: true},
			]
			if(this.userStore.hasReservations && this.experiencesStore.hasExperiences) {
				buttons.push({text: this.getString('reservation'), callback: this.newReservation, negative: true});
			}
			buttons.push({text: this.getString('confirm'), callback: this.openTable})
			return buttons;
		},
		formattedReservationsDate() {
			if(this.roomsOrdersStore.reservationsSelectedDate) {
				const date = new Date(this.roomsOrdersStore.reservationsSelectedDate);
				const isCurrentYear = date.getFullYear() === new Date().getFullYear();
				const options = { weekday: 'long', month: 'long', day: 'numeric' };
				if(!isCurrentYear) {
					options.year = 'numeric';
					options.month = 'short';
				}
				const formattedDate = date.toLocaleDateString(this.languageStore.lang, options);
				return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
			} else {
				return this.getString('no_date');
			}
		},
		isReservationsDateToday() {
			if(this.roomsOrdersStore.reservationsSelectedDate) {
				const today = new Date();
				const selectedDate = new Date(this.roomsOrdersStore.reservationsSelectedDate);
				return formatDateOnly(selectedDate) === formatDateOnly(today);
			}
			return false;
		},
		reservationsFiltersHighlighted() {
			if(this.roomsOrdersStore.reservationsFilters.hasOwnProperty("status")) {
				let defFilters = ["confirmed", "arrived"];
				return !arraysEqualIgnoreOrder(this.roomsOrdersStore.reservationsFilters.status, defFilters);
			} else if(this.roomsOrdersStore.reservationsFilters.hasOwnProperty("experiences")) {
				return this.experiencesStore.businessExperiences && this.roomsOrdersStore.reservationsFilters.experiences.length !== this.experiencesStore.businessExperiences.length;
			} else {
				return false;
			}
		},
		tablesCurrentReservations() {
			if(!this.reservationTimeCheck) {
				return {};
			}
			let result = {};
			let oneHourFromNow = new Date(this.reservationTimeCheck);
			oneHourFromNow.setTime(oneHourFromNow.getTime() + 60 * 60 * 1000);
			if(this.roomsStore.activeRoom) {
				this.roomsStore.activeRoom.tables.forEach(table => {
					table.reservations.forEach(reservation => {
						let newRes = null;
						if(reservation.status === "confirmed") {
							if(reservation.fullDate < oneHourFromNow) {
								newRes = reservation;
							}
						} else if(reservation.status === "arrived") {
							newRes = reservation;
						}
						if(newRes) {
							if(result.hasOwnProperty(table.room_table_id)) {
								let competingRes = result[table.room_table_id];
								if(competingRes.fullDate > newRes.fullDate) {
									result[table.room_table_id] = newRes;
								}
							} else {
								result[table.room_table_id] = newRes;
							}
						}
					});
				});
			}
			return result;
		}
	},
	methods: {
		toggleReservations() {
			this.roomsOrdersStore.reservationsTablesActive = !this.roomsOrdersStore.reservationsTablesActive;
			if(this.roomsOrdersStore.reservationsTablesActive) {
				this.$router.push('/ops/tables/reservations');
			} else {
				this.$router.push('/ops/tables');
			}
		},
		reservationsLeftClick() {
			if(this.roomsOrdersStore.reservationsSelectedDate) {
				this.roomsOrdersStore.reservationsSelectedDate = new Date(this.roomsOrdersStore.reservationsSelectedDate.getTime() - 24 * 60 * 60 * 1000);
			}
		},
		reservationsRightClick() {
			if(this.roomsOrdersStore.reservationsSelectedDate) {
				this.roomsOrdersStore.reservationsSelectedDate = new Date(this.roomsOrdersStore.reservationsSelectedDate.getTime() + 24 * 60 * 60 * 1000);
			}
		},
		newReservation() {
			this.roomsOrdersStore.newReservationTableId = this.openingTable.room_table_id;
			this.openingTable = null;
			this.$refs['confirm-cover'].toggleStatus(false);
		},
		refreshReservations() {
			this.roomsOrdersStore.getDayReservations();
			this.reservationsFiltersActive = false;
		},
		cancelOpenTable() {
			this.openingTable = null;
			this.$refs['confirm-cover'].toggleStatus(false);
		},
		payBillOrderCreated() {
			this.payBillTable = null;
		},
		togglingFilters(isOpen) {
			if(!isOpen) {
				this.filtersActive = false;
			}
		},
		togglingReservationsFilters(isOpen) {
			if(!isOpen) {
				this.reservationsFiltersActive = false;
			}
		},
		togglingPayBillTable(isOpen) {
			if(!isOpen) {
				this.payBillTable = false;
			}
		},
		changeSelectedRoom(room) {
			this.roomsStore.setActiveRoom(room.room_id);
		},
		clickTable(table) {
			this.openingTable = table;
			if(table.openDate) {
				this.goToOrders(table);
			} else {
				if(this.userStore.currPlans.counter) {
					this.coversNum = table.seat_number ? table.seat_number : 1;
					if(this.roomsStore.activeRoom?.cover_charge !== null) {
						this.$refs['confirm-cover'].toggleStatus(true);
					} else {
						this.openTable();
					}
				} else if(this.userStore.currPlans.pay_bill) {
					this.payBillTable = table;
				} else {
					this.notificationStore.showNotification("table-no-orders");
				}
			}
		},
		addOrderTable(table) {
			if(table.ordersNum === 1 && !table.allPrepared && this.userStore.checkOrderEditAllowed) {
				this.ordersStore.search = "tid:"+table.room_table_id;
				this.ordersStore.showCompleted = false;
				this.ordersStore.filterCounter = true;
				this.ordersStore.filterDelivery = true;
				this.ordersStore.filterTakeaway = true;
				this.ordersStore.filterRooms = true;
				this.ordersStore.refreshOrders(() => {
					let order = null;
					this.ordersStore.orderGroups.forEach(group => {
						group.orders.forEach(o => {
							if(o.room_table_id === table.room_table_id) {
								order = o;
							}
						});
					});
					if(order) {
						this.counterStore.startEditOrder(order);
						this.$router.push("/ops/counter");
					}
				});
				return;
			}

			this.openingTable = table;
			this.coversNum = 0;
			this.openTable();
			if(table.current_course) {
				this.counterStore.maxCourse = table.current_course;
				this.counterStore.selectedCourse = table.current_course;
			}
			this.$router.push("/ops/counter");
		},
		goToOrders(table) {
			this.ordersStore.search = "tid:"+table.room_table_id;
			this.ordersStore.showCompleted = false;
			this.ordersStore.filterCounter = true;
			this.ordersStore.filterDelivery = true;
			this.ordersStore.filterTakeaway = true;
			this.ordersStore.filterRooms = true;
			this.ordersStore.refreshOrders();
			this.$router.push("/ops/orders");
			this.ordersStore.activateMobileOrderSummary();
		},
		openTable() {

			if (!this.userStore.checkOrderCreationAllowed) {
				this.notificationStore.showNotification('permission-denied-order-creation');
				return;
			}

			this.counterStore.finishEditOrder();
			this.counterStore.selectedTable = this.openingTable;
			this.counterStore.selectedMode = "qr";
			if(this.roomsStore.activeRoom && this.roomsStore.activeRoom.cover_charge !== null) {
				this.counterStore.coverNum = this.coversNum;
				this.counterStore.coverCharge = this.roomsStore.activeRoom.cover_charge;
			} else {
				this.counterStore.coverNum = 0;
				this.counterStore.coverCharge = 0;
			}
			this.$refs['confirm-cover'].toggleStatus(false);
			this.$router.push("/ops/counter");
			this.openingTable = null;
		},
		updateTablesDates() {
			if(this.roomsStore.activeRoom) {
				this.roomsStore.activeRoom.tables.forEach(table => {
					if(table.openDate) {
						table.timeElapsedOpen = this.getTimeDiff(table.openDate);
					}
					table.reservations.forEach(reservation => {
						reservation.timeUntil = this.getTimeDiff(reservation.fullDate, true);
					});
				});
			}
		},
		getTimeDiff(date, future = false) {
			const now = new Date();
			const diff = future ? new Date(date) - now : now - new Date(date);
			let result;
			const minute = 60 * 1000;
			if(diff < minute) {
				result = "<1m";
			} else if(diff < 60 * minute) {
				result = Math.floor(diff / (60 * 1000)) + "m";
			} else if(diff < 24 * 60 * minute) {
				result = "+"+Math.floor(diff / (60 * 60 * 1000)) + "h";
			} else {
				result = ">1d";
			}
			return result;
		},
		roomCallsQuantity(roomId) {
			if(!this.roomsOrdersStore?.rtcRoomsIds || !this.roomsOrdersStore.rtcRoomsIds[roomId]) {
				return 0;
			}
			return Object.keys(this.roomsOrdersStore.rtcRoomsIds[roomId]).length;
		},
		openFirstRoomWithNotification() {
			if(this.roomsOrdersStore.shouldOpenFirstRoomWithNotification) {
				this.roomsOrdersStore.shouldOpenFirstRoomWithNotification = false;
				let newRoomId = this.roomsOrdersStore.getFirstRoomIdWithNotification();
				if(newRoomId) {
					this.roomsStore.setActiveRoom(newRoomId);
				}
			}
		},
		updateReservationTimeCheck() {
			this.reservationTimeCheck = new Date();
		}
	},
	mounted() {
		// Sync route with reservationsTablesActive state
		if(this.$route.path === '/ops/tables/reservations') {
			this.roomsOrdersStore.reservationsTablesActive = true;
		} else if(this.$route.path === '/ops/tables') {
			this.roomsOrdersStore.reservationsTablesActive = false;
		}
		
		this.ordersStore.tablesToCheck = false;
		this.roomsStore.getBusinessRooms(() => {
			this.openFirstRoomWithNotification();
			if(this.roomsStore.activeRoom) {
				this.roomsStore.updateRoomStatus(this.roomsStore.activeRoom, () => {
					this.updateTablesDates();
				});
			}
		}, false);
		this.updateTablesDates();
		this.dateInterval = setInterval(this.updateTablesDates, 1000);

		if(this.userStore.hasReservations) {
			this.updateReservationTimeCheck();
			this.reservationInterval = setInterval(this.updateReservationTimeCheck, 1000 * 60);
		}
	},
	beforeUnmount() {
		clearInterval(this.dateInterval);
		clearInterval(this.reservationInterval);
	},
	watch: {
		"roomsStore.activeRoomId": function() {
			if(this.roomsStore.activeRoom) {
				this.roomsStore.updateRoomStatus(this.roomsStore.activeRoom, () => {
					this.updateTablesDates();
					this.updateReservationTimeCheck();
				});
			}
		},
		'ordersStore.tablesToCheck': function(val) {
			if(val) {
				if(this.roomsStore.activeRoom) {
					this.ordersStore.tablesToCheck = false;
					this.roomsStore.updateRoomStatus(this.roomsStore.activeRoom, () => {
						this.updateTablesDates();
						this.updateReservationTimeCheck();
					});
				}
			}
		},
		'roomsOrdersStore.shouldOpenFirstRoomWithNotification'(newVal, oldVal) {
			if(newVal !== oldVal) {
				this.openFirstRoomWithNotification();
			}
		}
	}
}

function arraysEqualIgnoreOrder(a, b) {
	if (a.length !== b.length) return false;
	const sa = [...a].sort();
	const sb = [...b].sort();
	return sa.every((val, idx) => val === sb[idx]);
}
</script>

<style scoped lang="scss">
.tables-section-container {
	--orders-padding: 12px;
	position: relative;

	.rooms-container {
		background: rgba(var(--rgb-bg-primary-1), 67%);
		box-shadow: inset 0 -3px 6px var(--color-box-shadow-3);
		border-radius: 0;
		opacity: 1;
		backdrop-filter: blur(6px);
		-webkit-backdrop-filter: blur(6px);
		position: sticky;
		top: 0;
		left: 0;
		z-index: 5;
		padding: var(--orders-padding);
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
		min-height: 90px;

		&.reservations {
			flex-wrap: wrap;
		}

		@media (max-width: 920px) {
			border-radius: 0 0 13px 13px;
		}

		.switchs {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			gap: 10px;
			margin-left: auto;
		}

		.date-picker-container {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			gap: 10px;

			@media (max-width: 480px) {
				width: 100%;
			}

			.date-picker-button {
				background-color: var(--color-alpha-2);
				border-radius: 13px;
				width: 36px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}

			.reservation-date {
				border-radius: 13px;
				border: 1px solid var(--color-primary);
				padding: 6px 12px;
				cursor: pointer;
				min-width: 210px;
				text-align: center;
				font-size: 16px;
				line-height: 22px;

				&.today {
					background-color: var(--color-alpha-2);
				}

				@media (max-width: 480px) {
					flex-grow: 1;
				}
			}
		}

		.order-switch {
			border-radius: 13px;
			border: 1px solid var(--color-primary);
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 9px;
			cursor: pointer;
			flex-shrink: 0;
			transition: background-color 0.3s ease;
			width: 48px;
			height: 48px;

			&.active {
				background-color: var(--color-active-button);
			}

			:deep(svg) {
				width: 20px;
				height: 20px;

				.fill {
					fill: var(--color-primary);
				}

				.stroke {
					stroke: var(--color-primary);
				}
			}

			@media (max-width: 350px) {
				width: 38px;
				height: 38px;
				padding: 6px;

				:deep(svg) {
					width: 16px;
					height: 16px;
				}
			}

			&.primary {
				background-color: var(--color-primary);
				width: 62px;

				:deep(svg) {

					.fill {
						fill: var(--color-secondary);
					}

					.stroke {
						stroke: var(--color-secondary);
					}
				}
			}

		}

		.rooms-scroll-container {
			display: flex;
			flex-direction: row;
			align-items: center;
			overflow-x: auto;
			-ms-overflow-style: none;
			scrollbar-width: none;
			border-radius: 13px;
			background-color: var(--color-bg-primary-2);
			box-shadow: inset 2px 2px 3px var(--color-box-shadow-3);
			flex-grow: 1;
			min-height: 51px;

			.rooms-filter-container {
				border-radius: 13px;
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				align-items: center;
				padding: 8px;
				gap: 6px;
				width: 100%;
				height: 66px;

				.room {
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 13px;
					border: 1px solid var(--color-primary);
					cursor: pointer;
					user-select: none;
					transition: background-color 0.3s ease;
					height: 50px;
					flex: 1;
					min-width: 140px;
					max-width: 250px;

					@media (max-width: 950px) {
						min-width: 120px;
					}

					@media (max-width: 850px) {
						min-width: 100px;
					}

					@media (max-width: 750px) {
						min-width: 120px;
					}

					@media (max-width: 550px) {
						min-width: 100px;
					}

					.room-name {
						@include truncateString(1);
						max-width: 130px;
						color: var(--color-primary);
						font-size: 15px;
						width: fit-content;
						padding: 7px 12px;
						user-select: none;
					}

					&.active {
						background-color: var(--color-active-button);
						.room-name {
							color: var(--color-active-button-text);
						}
					}


					.cover-container {
						display: flex;
						flex-direction: row;
						justify-content: flex-start;
						align-items: center;
						box-shadow: inset 0 0 3px var(--color-box-shadow-3);
						background-color: var(--color-alpha-1);
						border-radius: 7px;
						padding: 4px 6px;
						margin-left: 4px;
						gap: 5px;

						@keyframes shakePulse {
							0% { transform: scale(1) rotate(0deg); }
							20% { transform: scale(1.1) rotate(5deg); }
							40% { transform: scale(1.3) rotate(-15deg); }
							60% { transform: scale(1.1) rotate(5deg); }
							80% { transform: scale(1) rotate(-5deg); }
							100% { transform: scale(1) rotate(0deg); }
						}
						
						.cover-icon {
							width: 14px;
							height: 14px;
							display: flex;
							justify-content: center;
							align-items: center;
							animation: shakePulse .5s 2 ease-in-out;

							&:deep(svg) {
								width: 100%;
								height: 100%;

								.fill {
									fill: var(--color-svg-primary);
								}

								.stroke {
									stroke: var(--color-svg-primary);
								}
							}
						}

						.cover-value {
							font-size: 14px;
							font-weight: 500;
							color: var(--color-primary);
						}
					}
					
					@keyframes slideInFromLeft {
						0% {
							opacity: 0;
							transform: translateX(-100%) scale(.6);
						}
						100% {
							opacity: 1;
							transform: translateX(0) scale(1);
						}
					}
					
					.cover-container {
						animation: slideInFromLeft .3s ease;
					}
				}

				@media (max-width: 900px) {
					padding: 8px;
					gap: 8px;
					min-height: 46px;
				}

			}
		}
	}

	.no-room {
		width: calc(100% - var(--orders-padding) * 2);
		background-color: var(--color-bg);
		border-radius: 13px;
		border: 2px dashed $primary;
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		min-height: 130px;
		gap: 6px;
		margin: var(--orders-padding);
		z-index: 0;
		position: relative;

		.no-room-text {
			font-size: 18px;
			color: $primary;
			font-weight: 700;
		}

		.no-room-subtitle {
			font-size: 14px;
			color: $primary;
			font-weight: 400;
		}
	}

	.tables-container {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 10px;
		padding-bottom: 20px;
		z-index: 0;
		position: relative;

		.table-container-wrapper {
			--num-items: 10;
			--width-item: 150px;
			width: calc(calc(100% / var(--num-items)));
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			margin-top: 10px;

			@media (max-width: 1800px) {
				--num-items: 9;
			}

			@media (max-width: 1670px) {
				--num-items: 8;
			}

			@media (max-width: 1435px) {
				--num-items: 7;
			}

			@media (max-width: 1250px) {
				--num-items: 6;
			}

			@media (max-width: 1070px) {
				--num-items: 5;
			}

			@media (max-width: 850px) {
				--num-items: 4;
			}

			@media (max-width: 670px) {
				--num-items: 3;
			}

			@media (max-width: 500px) {
				--num-items: 2;
			}

			@media (max-width: 340px) {
				--num-items: 1;
			}

			.table-container {
				border-radius: 13px;
				box-shadow: 0 3px 5px var(--color-box-shadow-2);
				display: flex;
				flex-direction: column;
				width: var(--width-item);
				gap: 6px;
				padding: 10px 10px 15px;
				flex-grow: 1;
				flex-shrink: 0;
				cursor: pointer;
				z-index: 10;
				--card-color: var(--color-bg);
				--accent-color: var(--color-primary);
				--gradient-start-color:var(--color-primary);
				background-color: var(--card-color);
				position: relative;

				&.free {
					--card-color: var(--color-table-free);
					--accent-color: var(--color-table-gradient-start-free);
					--gradient-start-color: var(--color-table-gradient-end-free);
				}

				&.occupied {
					--card-color: var(--color-table-occupied);
					--accent-color: var(--color-table-gradient-start-occupied);
					--gradient-start-color: var(--color-table-gradient-end-occupied);
				}

				&.closing {
					--card-color: var(--color-table-closing);
					--accent-color: var(--color-table-gradient-start-closing);
					--gradient-start-color: var(--color-table-gradient-end-closing);
				}

				&.reserved {
					&:after {
						content: "";
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background: linear-gradient(180deg, rgba(7,82,163,0) 0%, var(--color-primary-alpha-4) 60%, var(--color-primary-alpha-8) 100%);
						border-radius: 13px;
						z-index: 1;
					}
				}

				.icons-header {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 2px;
					z-index: 5;

					.cover-container {
						display: flex;
						flex-direction: row;
						justify-content: flex-start;
						align-items: center;
						box-shadow: inset 0 0 3px var(--color-box-shadow-3);
						background-color: var(--color-alpha-1);
						border-radius: 7px;
						padding: 9px 8px;
						gap: 5px;

						.cover-icon {
							width: 14px;
							height: 14px;
							display: flex;
							justify-content: center;
							align-items: center;

							&:deep(svg) {
								width: 100%;
								height: 100%;

								.fill {
									fill: var(--color-primary);
								}

								.stroke {
									stroke: var(--color-primary);
								}
							}
						}

						.cover-value {
							font-size: 14px;
							font-weight: 500;
							color: var(--color-primary);
						}
					}

					.orders-link {
						width: 36px;
						height: 36px;
						display: flex;
						justify-content: center;
						align-items: center;
						border: 1px solid var(--color-primary);
						background-color: var(--color-alpha-1);
						border-radius: 7px;
						padding: 9px;

						&:deep(svg) {
							width: 100%;
							height: 100%;

							.fill {
								fill: var(--color-primary);
							}

							.stroke {
								stroke: var(--color-primary);
							}
						}
					}
				}

				.table-name {
					font-size: 18px;
					font-weight: 700;
					text-align: center;
					@include truncateString(1);
					z-index: 5;
				}

				.order-value {
					font-size: 15px;
					text-align: center;
					margin-bottom: 6px;
					z-index: 5;
				}

				.table-status-container {
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 5;
					min-height: 30px;

					&.reserved {
						justify-content: space-between;
					}

					.reservation-time {
						background-color: var(--color-primary);
						border-radius: 15px;
						height: 30px;
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0 7px;
						gap: 5px;

						span {
							font-size: 13px;
							color: var(--color-txt-white);
						}

						.icon {
							display: flex;
							justify-content: center;
							align-items: center;
							height: 16px;
							width: 16px;

							:deep(svg) {
								height: 16px;
								width: 16px;

								.fill {
									fill: var(--color-txt-white);
								}

								.stroke {
									stroke: var(--color-txt-white);
								}
							}
						}
					}

					.table-status {
						position: relative;

						.table-status-circle {
							position: absolute;
							left: -3px;
							top: -3px;
							width: calc(100% + 6px);
							height: calc(100% + 6px);
							border-radius: 100px;
							background: linear-gradient(90deg, var(--gradient-start-color) 0%, var(--accent-color) 100%);
							z-index: -1;
						}

						p {
							padding: 0 10px;
							border-radius: 13px;
							background-color: var(--card-color);
							font-size: 15px;
							font-weight: 700;
							color: var(--accent-color);
						}
					}
				}
			}

			.table-bottom {
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-radius: 0 0 13px 13px;
				width: var(--width-item);
				border-left: 1px solid $primary;
				border-right: 1px solid $primary;
				border-bottom: 1px solid $primary;
				margin-top: -13px;
				padding: 18px 10px 5px;
				z-index: 5;
				transition: background-color .3s ease;

				p {
					font-size: 14px;
					font-weight: 500;
					color: $primary;
					@include truncateString(1);
				}

				.courses {
					box-shadow: inset 0 0 3px rgba(7, 82, 163, 0.3);
					background-color: rgba(7, 82, 163, 0.0666666667);
					border-radius: 7px;
					min-width: 30px;
					text-align: center;
				}

				//simple shake and pulse animation
				@keyframes shakePulse {
					0% { transform: scale(1) rotate(0deg); }
					20% { transform: scale(1.1) rotate(5deg); }
					40% { transform: scale(1.3) rotate(-15deg); }
					60% { transform: scale(1.1) rotate(5deg); }
					80% { transform: scale(1) rotate(-5deg); }
					100% { transform: scale(1) rotate(0deg); }
				}
				
				.bell-icon {
					display: none;
					margin-left: auto;
					margin-right: auto;
					animation: shakePulse .5s 2 ease-in-out;
					width: 19px;
					height: 19px;
					
					:deep(svg) {
						width: 100%;
						height: 100%;
						.fill {
							fill: var(--color-bg);
						}
					}
				}

				&.asked-assistance {
					cursor: pointer;
					background-color: $primary;

					.bell-icon {
						pointer-events: none;
						cursor: pointer;
						display: block;
					}
					p, .courses {
						display: none;
					}
				}
			}
		}

		&:after {
			content: "";
			flex-grow: 1;
		}

	}

	@media (max-width: 1080px) {
		--orders-padding: 10px;
	}


	@media (max-width: 750px) {
		--orders-padding: 8px;
	}
}
</style>